<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../util/mixinFilial";
import InputDatePicker from "../Widgets/InputDatePicker";
import Paginacao from "@/Components/Widgets/Paginacao.vue";
import jsPDF from "jspdf";

// Configurações das etiquetas
const ETIQUETAS_CONFIG = {
  A4_WIDTH: 210,
  A4_HEIGHT: 297,
  COLS: 3,
  ROWS: 8,
  MARGIN_LEFT: 5,      // Aumentado de 3 para 5mm
  MARGIN_RIGHT: 5,     // Nova margem direita
  MARGIN_TOP: 6,       // Aumentado de 4 para 6mm
  MARGIN_BOTTOM: 6,    // Nova margem inferior
  SPACING_X: 2,
  SPACING_Y: 1,
  get ETIQUETAS_POR_PAGINA() {
    return this.COLS * this.ROWS;
  },
  get ETIQUETA_WIDTH() {
    return (this.A4_WIDTH - this.MARGIN_LEFT - this.MARGIN_RIGHT - this.SPACING_X * (this.COLS - 1)) / this.COLS;
  },
  get ETIQUETA_HEIGHT() {
    return (this.A4_HEIGHT - this.MARGIN_TOP - this.MARGIN_BOTTOM - this.SPACING_Y * (this.ROWS - 1)) / this.ROWS;
  }
};

export default {
  name: "EtiquetasLojaGerarPdf",
  mixins: [mixinFilial],
  components: { Paginacao, InputDatePicker },
  data: () => ({
    produtosHistorico: [],

    fabComplete: [],
    secComplete: [],

    isVisible:false,
    isVisible2:false,
    dialogConfirma: false,
    carregandoPdfMensagem: '',
    qtdEtiquetas: 0,
    show:false,
    dialogIframe: false,
    pdfUrl:null,
    e6: 1,
    carregandoPdf: false,
    limite: 30,
    primeiraBusca:false,
    pgSelecionada: 0,
    panel: 0,
    dialogProdutosSelecionado: false,
    search: '',
    selected: [],
    selectedPrint: [],
    produtos: { lista: [], total: 0 },
    produtosGeral: { lista: [], total: 0 },
    filtrosEtiquetas: [],

    buscaPersonalizada:{
      busca: '',
      fabricantes:[],
      secoes:[],
      promocoes:[],
      idempresa: null,
      dtini: `${new Date().getFullYear()}-01-01`,
      dtfim: `${new Date(new Date())
          .toLocaleDateString("pt-BR")
          .split("/")
          .reverse()
          .join("-")}`,
      tipo: 'G',
      flagestoque: true,
    },

    filtrosUsados: {
      busca: "",
      tipo: 'G',
      fabricantes: [],
      secoes: [],
      promocoes: [],
      dtini: (() => {
        const agora = new Date();
        const ano = agora.getFullYear();
        const mes = String(agora.getMonth() + 1).padStart(2, '0');
        return `${ano}-${mes}-01`;
      })(),
      dtfim: (() => {
        const agora = new Date();
        const ano = agora.getFullYear();
        const mes = String(agora.getMonth() + 1).padStart(2, '0');
        const dia = String(agora.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
      })(),
      idempresa: null,
      flagestoque: null,
    },

    carregando2:false,
    carregando: false,
  }),
  computed: {
    ...mapState(["backendUrl", "usuario", "pgLimit"]),
    tipoRule2() {
      return (value) => value.length > 2 || '*Campo deve ter no mínimo 3 caracteres';
    },
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial != 6 &&
              v.idfilial != 33 &&
              v.idfilial != 37
          );
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    obterValoresUnicos(arrayGeral, propriedades, filtrosConfig) {
      // Filtrar o array geral com base nos filtros configurados
      let arrayFiltrado = arrayGeral;

      // Iterar sobre cada filtro configurado e aplicar a filtragem
      Object.keys(filtrosConfig).forEach(tipo => {
        if (filtrosConfig[tipo].length > 0) {
          arrayFiltrado = arrayFiltrado.filter(item => filtrosConfig[tipo].includes(item[tipo]));
        }
      });

      // Agrupar os dados pelas propriedades especificadas
      const agrupados = this.agruparPorPropriedades(arrayFiltrado, propriedades);

      // Transformar o objeto agrupado em um array de objetos únicos
      const resultado = Object.values(agrupados).map(grupo => {
        const [primeiroItem] = grupo; // Usar o primeiro item do grupo como representativo
        return propriedades.reduce((obj, prop) => {
          obj[prop] = primeiroItem[prop]; // Adicionar cada propriedade ao objeto resultante
          return obj;
        }, {});
      });

      return resultado;
    },

    agruparPorPropriedades(array, propriedades) {
      return array.reduce((acumulador, item) => {
        const chave = propriedades.map(prop => item[prop]).join('|'); // Criar uma chave única combinando os valores das propriedades
        if (!acumulador[chave]) {
          acumulador[chave] = [];
        }
        acumulador[chave].push(item);
        return acumulador;
      }, {});
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    checkScrollPosition() {
      this.isVisible = window.scrollY > 200;
      this.isVisible2 = window.scrollY > 550;
    },

    limpaFiltros(tipo, item){
      this.produtos.lista = [];
      this.produtos.total = 0;
      this.panel = 0;
      var index;
      switch (tipo) {
        case "promocoes":
          index = this.filtrosUsados.promocoes.indexOf(item);
          if (index !== -1) {
            this.filtrosUsados.promocoes.splice(index, 1);
          }
          this.focusCampo('promocoes');
          break;
        case "fabricantes":
          index = this.filtrosUsados.fabricantes.indexOf(item);
          if (index !== -1) {
            this.filtrosUsados.fabricantes.splice(index, 1);
          }
          this.$nextTick(() => {
            this.focusCampo(this.$refs.refFabricante);
          });
          this.focusCampo('fabricantes');
          break;
        case "secoes":
          index = this.filtrosUsados.secoes.indexOf(item);
          if (index !== -1) {
            this.filtrosUsados.secoes.splice(index, 1);
          }
          this.focusCampo('secoes');
          break;
        case "produto":
          this.filtrosUsados.busca = ''
          this.buscaPersonalizada.busca = ''
          this.focusCampo('produto');
          break;
        case "data":
          this.buscaPersonalizada = {
            busca: this.buscaPersonalizada.busca,
            fabricantes:[],
            secoes:[],
            promocoes:[],
            dtini: this.buscaPersonalizada.dtini,
            dtfim: this.buscaPersonalizada.dtfim,
            tipo: this.buscaPersonalizada.tipo,
            idempresa: this.buscaPersonalizada.idempresa || this.usuario.idfilial,
            flagestoque: this.buscaPersonalizada.flagestoque,
          };
          break;
        default:
          this.filtrosUsados= {
            busca: "",
            tipo: 'G',
            fabricantes: [],
            secoes: [],
            promocoes: [],
            dtini: `${new Date().getFullYear()}-01-01`,
            dtfim: `${new Date(new Date())
                .toLocaleDateString("pt-BR")
                .split("/")
                .reverse()
                .join("-")}`,
            idempresa: this.usuario.idfilial,
            flagestoque: null,
          };
          this.buscaPersonalizada = {
            busca: '',
            fabricantes:[],
            secoes:[],
            promocoes:[],
            dtini: `${new Date().getFullYear()}-01-01`,
            dtfim: `${new Date(new Date())
                .toLocaleDateString("pt-BR")
                .split("/")
                .reverse()
                .join("-")}`,
            tipo: this.buscaPersonalizada.tipo,
            idempresa: this.buscaPersonalizada.idempresa || this.usuario.idfilial,
            flagestoque: this.buscaPersonalizada.flagestoque,
          };
          break;
      }
    },

    focusCampo(ref) {
      var campo;
      switch (ref) {
        case "promocoes":
          this.$nextTick(() => {
            campo = this.$refs.refPromocao;
            if (campo && campo.$el && campo.$el.offsetParent !== null) {
              campo.focus();
            } else {
              setTimeout(this.focusCampo('promocoes'), 100);
            }
          });
          break;
        case "fabricantes":
          this.$nextTick(() => {
            campo = this.$refs.refFabricante;
            if (campo && campo.$el && campo.$el.offsetParent !== null) {
              campo.focus();
            } else {
              setTimeout(this.focusCampo('fabricantes'), 100);
            }
          });
          break;
        case "secoes":
          this.$nextTick(() => {
            campo = this.$refs.refSecao;
            if (campo && campo.$el && campo.$el.offsetParent !== null) {
              campo.focus();
            } else {
              setTimeout(this.focusCampo('secoes'), 100);
            }
          });
          break;
        case "produto":
          this.$nextTick(() => {
            campo = this.$refs.refProduto;
            if (campo && campo.$el && campo.$el.offsetParent !== null) {
              campo.focus();
            } else {
              setTimeout(this.focusCampo('produto'), 100);
            }
          });
          break;
      }
    },

    /**
     * Desenha uma única etiqueta no PDF
     */
    /**
     * Desenha uma única etiqueta no PDF
     */
    desenharEtiqueta(pdf, produto, x, y) {
      const config = ETIQUETAS_CONFIG;
      const agora = new Date();
      const ano = agora.getFullYear();
      const mes = String(agora.getMonth() + 1).padStart(2, '0');
      const dia = String(agora.getDate()).padStart(2, '0');
      const dataFormatada = `${ano}${mes}${dia}`;

      // Borda da etiqueta
      pdf.setDrawColor(0);
      pdf.setLineWidth(0.1);
      pdf.rect(x, y, config.ETIQUETA_WIDTH, config.ETIQUETA_HEIGHT);

      // Nome do produto (topo, usando toda a largura agora - SEM "Cód.")
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      const nomeProduto = (produto.produto || '').toUpperCase();
      const maxWidth = config.ETIQUETA_WIDTH - 4; // Usa toda a largura disponível
      const linhasNome = pdf.splitTextToSize(nomeProduto, maxWidth);
      const linhasParaMostrar = linhasNome.slice(0, 2); // Máximo 2 linhas

      pdf.text(linhasParaMostrar, x + 2, y + 3.5);

      // Código de barras (imagem base64)
      if (produto.base64) {
        const imgWidth = 55;
        const imgHeight = 15;
        const imgX = x + (config.ETIQUETA_WIDTH - imgWidth) / 2;
        const imgY = y + 12;

        try {
          pdf.addImage(
              `data:image/png;base64,${produto.base64}`,
              'PNG',
              imgX,
              imgY,
              imgWidth,
              imgHeight,
              undefined,
              'FAST' // Compressão rápida
          );
        } catch (error) {
          console.error('Erro ao adicionar imagem do código de barras:', error);
          // Desenha um retângulo placeholder se a imagem falhar
          pdf.setDrawColor(200);
          pdf.rect(imgX, imgY, imgWidth, imgHeight);
        }
      }

      // Número do código de barras (com mais espaço e fonte maior)
      pdf.setFontSize(9); // Aumentado de 7 para 9
      const codigoBarra = produto.codigobarra || '';
      pdf.text(codigoBarra, x + config.ETIQUETA_WIDTH / 2, y + 30, { align: 'center' }); // Aumentado de 29 para 30

      // Data (canto inferior esquerdo)
      pdf.setFontSize(6);
      pdf.text(dataFormatada, x + 2, y + config.ETIQUETA_HEIGHT - 1.5);

      // Código do produto (canto inferior direito, vertical)
      const codigoProduto = String(produto.idsubproduto || '');
      const digitosProduto = codigoProduto.split('');

      pdf.setFontSize(7);
      let offsetY = y + 12;
      digitosProduto.forEach(digito => {
        pdf.text(digito, x + config.ETIQUETA_WIDTH - 3, offsetY);
        offsetY += 2.5;
      });
    },

    /**
     * Gera PDF com etiquetas selecionadas
     */
    async geraEtiquetas() {
      this.dialogProdutosSelecionado = false;
      this.carregandoPdf = true;
      this.carregandoPdfMensagem = 'Aguarde, armazenando histórico...';

      try {
        await this.gravaHistorico();

        // Expande os produtos com quantidade
        const dados = this.selected.flatMap(item => Array(item.quantidade).fill(item));

        if (dados.length === 0) {
          this.$toast.warning('Nenhuma etiqueta selecionada');
          this.carregandoPdf = false;
          return;
        }

        this.carregandoPdfMensagem = 'Gerando PDF das etiquetas...';

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4',
          compress: true
        });

        const config = ETIQUETAS_CONFIG;
        const totalEtiquetas = dados.length;
        const totalPaginas = Math.ceil(totalEtiquetas / config.ETIQUETAS_POR_PAGINA);

        for (let pagina = 0; pagina < totalPaginas; pagina++) {
          if (pagina > 0) {
            pdf.addPage();
          }

          const startIndex = pagina * config.ETIQUETAS_POR_PAGINA;
          const endIndex = Math.min(startIndex + config.ETIQUETAS_POR_PAGINA, totalEtiquetas);

          this.carregandoPdfMensagem = `Gerando página ${pagina + 1} de ${totalPaginas}...`;

          // Desenha cada etiqueta na página
          for (let i = startIndex; i < endIndex; i++) {
            const etiquetaIndex = i - startIndex;
            const row = Math.floor(etiquetaIndex / config.COLS);
            const col = etiquetaIndex % config.COLS;

            const x = config.MARGIN_LEFT + col * (config.ETIQUETA_WIDTH + config.SPACING_X);
            const y = config.MARGIN_TOP + row * (config.ETIQUETA_HEIGHT + config.SPACING_Y);

            this.desenharEtiqueta(pdf, dados[i], x, y);
          }

          // Pequeno delay para não travar a UI
          if (pagina % 5 === 0) {
            await new Promise(resolve => setTimeout(resolve, 10));
          }
        }

        // Gera o nome do arquivo
        // const agora = new Date();
        // const timestamp = agora.toISOString().replace(/[:.]/g, '-').slice(0, -5);
        // const nomeArquivo = `Etiquetas_${timestamp}.pdf`;
        //
        // // Salva o PDF
        // pdf.save(nomeArquivo);

        const blob = pdf.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');

        this.$toast.success(`PDF gerado com sucesso! ${totalEtiquetas} etiquetas em ${totalPaginas} página(s)`);

      } catch (error) {
        console.error('Erro ao gerar etiquetas:', error);
        this.$toast.error('Erro ao gerar PDF das etiquetas');
      } finally {
        this.carregandoPdf = false;
        this.carregandoPdfMensagem = '';
      }
    },

    /**
     * Gera PDF com todas as etiquetas (modo geral)
     */
    async geraEtiquetasGeral() {
      this.dialogConfirma = false;
      this.carregandoPdf = true;
      this.carregandoPdfMensagem = `Aguarde, buscando dados de ${this.produtos.total} produtos...`;

      try {
        await this.listarProdutosGeral();

        const dados = this.produtosGeral.lista;

        if (dados.length === 0) {
          this.$toast.warning('Nenhum produto encontrado');
          this.carregandoPdf = false;
          return;
        }

        this.carregandoPdfMensagem = 'Gerando PDF das etiquetas...';

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4',
          compress: true
        });

        const config = ETIQUETAS_CONFIG;
        const totalEtiquetas = dados.length;
        const totalPaginas = Math.ceil(totalEtiquetas / config.ETIQUETAS_POR_PAGINA);

        for (let pagina = 0; pagina < totalPaginas; pagina++) {
          if (pagina > 0) {
            pdf.addPage();
          }

          const startIndex = pagina * config.ETIQUETAS_POR_PAGINA;
          const endIndex = Math.min(startIndex + config.ETIQUETAS_POR_PAGINA, totalEtiquetas);

          this.carregandoPdfMensagem = `Gerando página ${pagina + 1} de ${totalPaginas}...`;

          // Desenha cada etiqueta na página
          for (let i = startIndex; i < endIndex; i++) {
            const etiquetaIndex = i - startIndex;
            const row = Math.floor(etiquetaIndex / config.COLS);
            const col = etiquetaIndex % config.COLS;

            const x = config.MARGIN_LEFT + col * (config.ETIQUETA_WIDTH + config.SPACING_X);
            const y = config.MARGIN_TOP + row * (config.ETIQUETA_HEIGHT + config.SPACING_Y);

            this.desenharEtiqueta(pdf, dados[i], x, y);
          }

          // Pequeno delay para não travar a UI
          if (pagina % 5 === 0) {
            await new Promise(resolve => setTimeout(resolve, 10));
          }
        }

        // Gera o nome do arquivo
        // const agora = new Date();
        // const timestamp = agora.toISOString().replace(/[:.]/g, '-').slice(0, -5);
        // const nomeArquivo = `Etiquetas_Geral_${timestamp}.pdf`;

        // Salva o PDF
        // pdf.save(nomeArquivo);

        const blob = pdf.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');


        this.$toast.success(`PDF gerado com sucesso! ${totalEtiquetas} etiquetas em ${totalPaginas} página(s)`);

      } catch (error) {
        console.error('Erro ao gerar etiquetas gerais:', error);
        this.$toast.error('Erro ao gerar PDF das etiquetas');
      } finally {
        this.carregandoPdf = false;
        this.carregandoPdfMensagem = '';
      }
    },

    async gravaHistorico(){
      this.produtosHistorico = this.selected.map((v) => {
        return {
          tela: 'Deposito',
          referencia: 'Selecionados',
          idempresa: this.buscaPersonalizada.idempresa || null,
          idproduto: v.idproduto,
          idsubproduto: v.idsubproduto,
          preco: v.preco,
          precopromocao: v.precopromocao,
          idpromocao: v.idpromocao,
          dtinipromocao: v.dtinipromocao,
          dtfimpromocao: v.dtfimpromocao,
        };
      });
      return axios
          .post(`${this.backendUrl}etiqueta/historico/gravar`, {
            produtos: this.produtosHistorico
          })
          .then(() => {
            // Histórico gravado com sucesso
          })
          .catch((error) =>{
            console.error('Erro ao gravar histórico:', error);
            this.carregando = false;
            this.carregandoPdf = false;
          });
    },

    verificaQuantidade(item) {
      const registroIndex = this.selected.findIndex(o => o.compositeKey === item.compositeKey);
      if (registroIndex !== -1 ) {
        this.selected[registroIndex].quantidade = item.quantidade;
      }

      this.qtdEtiquetas = this.selected.flatMap(item => Array(item.quantidade).fill(item)).length;
    },

    isItemSelected(item) {
      this.qtdEtiquetas = this.selected.flatMap(item => Array(item.quantidade).fill(item)).length;
      return this.selected.some(selectedItem => selectedItem.compositeKey === item.compositeKey);
    },

    listarProdutosGeral(pg = 0) {
      this.pgSelecionada = pg;
      return axios
          .post(`${this.backendUrl}etiqueta/listar`, {
            busca: this.buscaPersonalizada.busca,
            idempresa: this.buscaPersonalizada.idempresa || this.usuario.idfilial,
            tipo: this.buscaPersonalizada.tipo,
            idpromocao: this.buscaPersonalizada.promocoes.join(",") || null,
            idsecao: this.buscaPersonalizada.secoes.join(",") || null,
            idfabricante: this.buscaPersonalizada.fabricantes.join(",") || null,
            dtini: this.buscaPersonalizada.dtini,
            dtfim: this.buscaPersonalizada.dtfim,
            limit: 100,
            offset: 100 * pg,
            flaggeral: true,
            flagestoque: this.buscaPersonalizada.flagestoque,
          })
          .then((res) => {
            this.produtosGeral.lista = res.data.lista || [];
            this.produtosGeral.total = res.data.total || 0;
          })
          .catch((error) => {
            console.error('Erro ao listar produtos gerais:', error);
            this.carregando = false;
            this.carregandoPdf = false;
          });
    },

    listarProdutosPersonalizados(pg = 0) {
      this.pgSelecionada = pg;
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}etiqueta/listar`, {
            busca: this.buscaPersonalizada.busca,
            idempresa: this.buscaPersonalizada.idempresa || this.usuario.idfilial,
            tipo: 'G',
            idpromocao: this.buscaPersonalizada.promocoes.join(",") || null,
            idsecao: this.buscaPersonalizada.secoes.join(",") || null,
            idfabricante: this.buscaPersonalizada.fabricantes.join(",") || null,
            dtini: this.buscaPersonalizada.dtini,
            dtfim: this.buscaPersonalizada.dtfim,
            limit: 100,
            offset: 100 * pg,
            flaggeral: false,
            flagestoque: this.buscaPersonalizada.flagestoque
          })
          .then((res) => {
            const lista = res.data.lista || [];
            this.produtos.lista = lista.map((v) => {
              const compositeKey = `${v.idsubproduto}-${(v.preco - v.precopromocao).toFixed(2)}-${v.idpromocao}`;
              const selectedProduto = this.selected.find(u => u.compositeKey === compositeKey);
              const quantidade = selectedProduto ? selectedProduto.quantidade : 1;
              return {
                ...v,
                compositeKey: compositeKey,
                quantidade: quantidade,
              };
            });

            this.produtos.total = res.data.total || 0;
            this.carregando = false;
            this.primeiraBusca = true;

            this.filtrosUsados = {
              busca: this.buscaPersonalizada.busca || '',
              idempresa: this.buscaPersonalizada.idempresa || this.usuario.idfilial,
              dtini: this.buscaPersonalizada.dtini || '',
              dtfim: this.buscaPersonalizada.dtfim || '',
              tipo: this.buscaPersonalizada.tipo || '',
              fabricantes: this.buscaPersonalizada.fabricantes.length > 0 ? this.buscaPersonalizada.fabricantes : [],
              promocoes: this.buscaPersonalizada.promocoes.length > 0 ? this.buscaPersonalizada.promocoes : [],
              secoes: this.buscaPersonalizada.secoes.length > 0 ? this.buscaPersonalizada.secoes : [],
              flagestoque: this.buscaPersonalizada.flagestoque,
            };
          })
          .catch((error) => {
            console.error('Erro ao listar produtos personalizados:', error);
            this.carregando = false;
            this.carregandoPdf = false;
          });
    },

    listarFiltros(tipo) {
      this.buscaPersonalizada.promocoes = [];
      this.filtrosEtiquetas = [];
      this.limpaFiltros(tipo);
      return axios
          .post(`${this.backendUrl}etiqueta/filtro/listar`, {
            idempresa: this.buscaPersonalizada.idempresa,
            dtini: this.buscaPersonalizada.dtini,
            dtfim: this.buscaPersonalizada.dtfim,
            tipo: this.buscaPersonalizada.tipo,
            flagestoque: this.buscaPersonalizada.flagestoque,
            busca: this.buscaPersonalizada.busca,
          })
          .then((res) => {
            this.filtrosEtiquetas = res.data.EtiquetaFiltro == null ? [] : res.data.EtiquetaFiltro;
          })
          .catch((error) =>{
            console.error('Erro ao listar filtros:', error);
            this.carregando = false;
            this.carregandoPdf = false;
          });
    },

    async init() {
      await this.listarFiltros();
    },
  },
  mounted() {
    window.addEventListener('scroll', this.checkScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScrollPosition);
  },
  created() {
    this.buscaPersonalizada.idempresa = this.usuario.idfilial;
    this.init();
  },
};
</script>

<template>
  <v-row>
    <v-col cols="12" class="d-none d-md-block">
      <v-card dark color="primary">
        <v-expansion-panels v-model="panel">
          <v-expansion-panel class="primary">
            <v-expansion-panel-header class="pl-2 pr-7 py-0">
              <v-card-title>
                Filtros de busca: Depósito
                <v-card-text class="pa-0" v-if="primeiraBusca">
                  <v-col cols="12" class="px-0">
                    <span v-if="!carregando">{{produtos.total}} resultados encontrados.</span>
                  </v-col>
                  <v-col cols="12" class="px-2" >
                    <v-row v-if="!carregando">
                      <span>
                        <v-chip label small class="success ma-1">Filial {{ filtrosUsados.idempresa }}</v-chip>
                      </span>
                      <span>
                        <v-chip v-show="filtrosUsados.flagestoque" label small class="success ma-1"> SOMENTE PRODUTOS COM ESTOQUE </v-chip>
                      </span>
                      <span>
                        <v-chip v-show="filtrosUsados.tipo=='G'" label small class="success ma-1">{{filtrosUsados.dtini | formataData}} á {{filtrosUsados.dtfim | formataData}}</v-chip>
                        <v-chip v-show="filtrosUsados.tipo=='P'" label small class="success ma-1"> Somente Promoções </v-chip>
                      </span>
                      <span v-if="filtrosUsados.busca">
                        <v-chip @click:close="limpaFiltros('produto', filtrosUsados.busca)" label small close class="success ma-1"> Filtrado por: "{{filtrosUsados.busca}}"</v-chip>
                      </span>
                      <span v-for="(item) in filtrosUsados.secoes" :key="item">
                        <v-chip @click:close="limpaFiltros('secoes', item)" label close small class="success ma-1">{{filtrosEtiquetas.find(v => v.idsecao == item).secao}}</v-chip>
                      </span>
                      <span v-for="(item) in filtrosUsados.fabricantes" :key="item">
                        <v-chip @click:close="limpaFiltros('fabricantes', item)" label close small class="success ma-1">{{filtrosEtiquetas.find(v => v.idfabricante == item).fabricante}}</v-chip>
                      </span>
                      <span v-for="(item) in filtrosUsados.promocoes" :key="item">
                        <v-chip v-show="filtrosUsados.tipo=='P'" @click:close="limpaFiltros('promocoes', item)" label close small class="success ma-1">{{filtrosEtiquetas.find(v => v.idpromocao == item).promocao}}</v-chip>
                      </span>
                    </v-row>
                    <v-row v-else>
                      <v-progress-circular
                          class="mt-1 mr-1"
                          indeterminate
                          color="white"
                          :size="12"
                      ></v-progress-circular>
                      <span class="text-caption font-italic">Carregando...</span>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card-title>
            </v-expansion-panel-header>
            <v-divider/>
            <v-expansion-panel-content class="ml-n6 mr-n6 pt-6 pb-0">
              <v-card-text class="pr-5 py-0">
                <v-row>
                  <v-col cols="4">
                    <v-select
                        label="Filial"
                        :items="filiaisFiltro"
                        item-text="filial"
                        item-value="idfilial"
                        v-model="buscaPersonalizada.idempresa"
                        dense
                        hide-details
                        outlined
                        @change="listarFiltros('data')"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="4" v-show="buscaPersonalizada.tipo=='G'">
                    <InputDatePicker
                        @input="listarFiltros('data')"
                        v-model="buscaPersonalizada.dtini"
                        label="Período inicial"
                        :outlined="true"
                        :dense="true"
                    />
                  </v-col>
                  <v-col cols="4" v-show="buscaPersonalizada.tipo=='G'">
                    <InputDatePicker
                        v-model="buscaPersonalizada.dtfim"
                        label="Período final"
                        :outlined="true"
                        :dense="true"
                        @input="listarFiltros('data')"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field hide-details ref="refProduto" v-model="buscaPersonalizada.busca" outlined dense label="Código ou descrição do produto"></v-text-field>
                  </v-col>
                  <v-col cols="4" v-if="true">
                    <v-autocomplete
                        label="Seções"
                        :items="obterValoresUnicos(filtrosEtiquetas, ['idsecao','secao'], {'idpromocao': buscaPersonalizada.promocoes, 'idfabricante': buscaPersonalizada.fabricantes})"
                        item-text="secao"
                        item-value="idsecao"
                        v-model="buscaPersonalizada.secoes"
                        dense
                        multiple
                        outlined
                        hide-details
                        clearable
                        ref="refSecao"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                            v-if="index === 0"
                            :key="item.idsecao"
                            color="success"
                            class="ma-1"
                            small
                        >
                          <span class="text-caption">{{ item.secao }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="white--text text-caption">
                            (+{{ buscaPersonalizada.secoes.length - 1 }})
                          </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" v-if="true">
                    <v-autocomplete
                        label="Fabricantes"
                        :items="obterValoresUnicos(filtrosEtiquetas, ['idfabricante','fabricante'], {'idpromocao':buscaPersonalizada.promocoes,'idsecao':buscaPersonalizada.secoes})"
                        item-text="fabricante"
                        item-value="idfabricante"
                        v-model="buscaPersonalizada.fabricantes"
                        outlined
                        dense
                        hide-details
                        multiple
                        clearable
                        ref="refFabricante"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                            v-if="index === 0"
                            :key="item.idfabricante"
                            color="success"
                            class="ma-1"
                            small
                        >
                          {{ item.fabricante }}
                        </v-chip>
                        <span v-if="index === 1" class="white--text text-caption">
                                (+{{ buscaPersonalizada.fabricantes.length - 1 }})
                              </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" class="py-1" v-show="buscaPersonalizada.tipo=='G'">
                    <v-switch hide-details class="mt-0" color="success" v-model="buscaPersonalizada.flagestoque" label="Somente produtos com estoque"></v-switch>
                  </v-col>
                  <v-col cols="12" class="pa-0 pt-2"><v-divider class="white--text" /></v-col>
                  <v-col cols="6">
                    <v-btn :disabled="carregando || (buscaPersonalizada.tipo=='P' && buscaPersonalizada.promocoes.length==0)" :loading="carregando" class="success" @click="listarProdutosPersonalizados(0), panel=1" width="100%">
                      Buscar Produtos
                      <v-icon class="ml-1">mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn :disabled="carregando" :loading="carregando" light width="100%" @click="limpaFiltros">
                      Limpar Filtros
                      <v-icon class="ml-1">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-col>
    <v-col cols="12" class="d-md-none">
      <v-row>
        <v-col cols="12">
          <v-stepper v-if="true" class="primary pb-7" dark v-model="e6" vertical>
            <v-stepper-step :complete="e6>1" :editable="e6>1"  step="1" class="py-3 my-3"> Loja </v-stepper-step>
            <v-stepper-content step="1" class="pa-0">
              <v-row align="start"  class="ml-2 mr-12">
                <v-col cols="12" class="pb-0">
                  <v-select
                      :items="filiaisFiltro"
                      item-text="filial"
                      item-value="idfilial"
                      v-model="buscaPersonalizada.idempresa"
                      dense
                      hide-details
                      outlined
                      @change="listarFiltros('data')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" class="text-right pb-6">
                  <v-btn disabled small text color="white" @click="e6 = 1">Voltar</v-btn>
                  <v-btn small color="success" @click="e6 = 2">Próximo</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-step :complete="e6>2" :editable="e6>2" step="2" class="py-3 my-3"> Tipo de busca</v-stepper-step>
            <v-stepper-content step="2" class="pl-0 py-0">
              <v-row align="end" class="mt-1 ml-2">
                <v-col cols="12" class="pa-0 pt-2">
                  <v-radio-group hide-details v-model="buscaPersonalizada.tipo" class="ma-0 pa-0" row>
                    <v-col cols="12" class="py-0 pb-3">
                      <v-radio color="success" label="Período / Alteração" value="G" @click="listarFiltros('geral')"></v-radio>
                    </v-col>
                    <v-col cols="12" class="py-0 pb-3">
                      <v-radio color="success" label="Produto" value="E" @click="listarFiltros('geral')"></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="text-right pb-6">
                  <v-btn small text color="white" @click="e6 = 1">Voltar</v-btn>
                  <v-btn small color="success" @click="e6 = 3">Próximo</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-step :complete="e6>3" :editable="e6>3" step="3" class="py-3 my-3"> {{ buscaPersonalizada.tipo=='G' ? 'Período de alteração' : 'Busca por produto' }} </v-stepper-step>
            <v-stepper-content step="3" class="pl-0 py-0">
              <v-row v-show="buscaPersonalizada.tipo=='G'" align="end" class="mt-1 ml-2">
                <v-col cols="12" class="pt-0">
                  <InputDatePicker
                      @input="listarFiltros('data')"
                      :disabled="carregando"
                      v-model="buscaPersonalizada.dtini"
                      label="Período inicial"
                      :outlined="true"
                      :dense="true"
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <InputDatePicker
                      @input="listarFiltros('data')"
                      :disabled="carregando"
                      v-model="buscaPersonalizada.dtfim"
                      label="Período final"
                      :outlined="true"
                      :dense="true"
                  />
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-switch hide-details class="mt-0" color="success" v-model="buscaPersonalizada.flagestoque" label="Somente produtos com estoque"></v-switch>
                </v-col>
                <v-col cols="12" class="text-right pb-6">
                  <v-btn small text color="white" @click="e6 = 2">Voltar</v-btn>
                  <v-btn small color="success" @click="e6 = 4">Próximo</v-btn>
                </v-col>
              </v-row>
              <v-row v-show="buscaPersonalizada.tipo=='E'" align="end" class="mt-1 ml-2">
                <v-col cols="12" class="pt-0">
                  <v-text-field class="mb-n6" :rules="[tipoRule2]" v-model="buscaPersonalizada.busca" outlined dense label="Código ou descrição do produto"></v-text-field>
                </v-col>
                <v-col cols="12" class="text-right pb-6">
                  <v-btn small text color="white" @click="e6 = 2">Voltar</v-btn>
                  <v-btn small color="success" @click="e6 = 4, listarFiltros('data')" :disabled="buscaPersonalizada.busca.length < 3">Próximo</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-step :complete="e6>4" :editable="e6>4" step="4" class="py-3 my-3"> Seções </v-stepper-step>
            <v-stepper-content step="4" class="pl-0 py-0">
              <v-row align="end" class="d-block mt-1 ml-2">
                <v-col cols="12" class="py-0">
                  <v-select
                      label="Seções"
                      :items="obterValoresUnicos(filtrosEtiquetas, ['idsecao','secao'], {'idpromocao': buscaPersonalizada.promocoes, 'idfabricante': buscaPersonalizada.fabricantes})"
                      item-text="secao"
                      item-value="idsecao"
                      v-model="buscaPersonalizada.secoes"
                      dense
                      multiple
                      outlined
                      hide-details
                      clearable
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                          v-if="index === 0"
                          :key="item.idsecao"
                          color="success"
                          class="ma-1"
                          small
                      >
                        <span class="text-caption">{{ item.secao }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="white--text text-caption">
                            (+{{ buscaPersonalizada.secoes.length - 1 }})
                          </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" class="text-right pb-6">
                  <v-btn small text color="white" @click="e6 = 3, buscaPersonalizada.secoes=[], filtrosUsados.secoes=[]">Voltar</v-btn>
                  <v-btn small color="success" @click="e6 = 5">Próximo</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-step :complete="e6>5" :editable="e6>5" step="5" class="py-3 my-3"> Fabricantes </v-stepper-step>
            <v-stepper-content step="5" class="pl-0 py-0">
              <v-row align="end" class="d-block mt-1 ml-2">
                <v-col cols="12" class="py-0">
                  <v-select
                      label="Fabricantes"
                      :items="obterValoresUnicos(filtrosEtiquetas, ['idfabricante','fabricante'], {'idpromocao':buscaPersonalizada.promocoes,'idsecao':buscaPersonalizada.secoes})"
                      item-text="fabricante"
                      item-value="idfabricante"
                      v-model="buscaPersonalizada.fabricantes"
                      outlined
                      dense
                      hide-details
                      multiple
                      clearable
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                          v-if="index === 0"
                          :key="item.idfabricante"
                          color="success"
                          class="ma-1"
                          small
                      >
                        {{ item.fabricante }}
                      </v-chip>
                      <span v-if="index === 1" class="white--text text-caption">
                                (+{{ buscaPersonalizada.fabricantes.length - 1 }})
                              </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" class="text-right pb-6">
                  <v-btn small text color="white" @click="e6 = 4, buscaPersonalizada.fabricantes=[], filtrosUsados.fabricantes=[]" >Voltar</v-btn>
                  <v-btn small color="success" @click="e6 = 6">Próximo</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-step step="6" class="py-3 my-3"> Finalização </v-stepper-step>
            <v-stepper-content step="6" class="px-0 mx-4 pt-0 pb-1 ">
              <v-divider class="pb-3" />
              <v-col cols="12" class="pa-0 mb-6">
                <fieldset>
                  <legend>Filtros de pesquisa</legend>
                  <span>
                    <v-chip label x-small class="success ma-1">Filial {{ buscaPersonalizada.idempresa }}</v-chip>
                  </span>
                  <span>
                    <v-chip v-show="buscaPersonalizada.flagestoque" label x-small class="success ma-1"> SOMENTE PRODUTOS COM ESTOQUE </v-chip>
                  </span>
                  <span>
                      <v-chip v-show="buscaPersonalizada.tipo=='G'" label x-small class="success ma-1">{{buscaPersonalizada.dtini | formataData}} á {{buscaPersonalizada.dtfim | formataData}}</v-chip>
                      <v-chip v-show="buscaPersonalizada.tipo=='P'" label x-small class="success ma-1"> Somente Promoções </v-chip>
                  </span>
                  <span v-for="(item) in buscaPersonalizada.promocoes" :key="item">
                      <v-chip label x-small  class="success ma-1">{{filtrosEtiquetas.find(v => v.idpromocao == item).promocao}}</v-chip>
                  </span>
                  <span v-for="(item) in buscaPersonalizada.fabricantes" :key="item">
                      <v-chip label x-small  class="success ma-1">{{filtrosEtiquetas.find(v => v.idfabricante == item).fabricante}}</v-chip>
                  </span>
                  <span v-for="(item) in buscaPersonalizada.secoes" :key="item">
                      <v-chip label x-small  class="success ma-1">{{filtrosEtiquetas.find(v => v.idsecao == item).secao}}</v-chip>
                  </span>
                  <span v-if="buscaPersonalizada.busca">
                      <v-chip label x-small  class="success ma-1"> Filtrar por: "{{buscaPersonalizada.busca}}"</v-chip>
                  </span>
                </fieldset>
              </v-col>
              <v-row align="end">
                <v-col cols="6" class="pr-2">
                  <v-btn small :disabled="carregando" :loading="carregando" light width="100%" @click="e6 = 5">
                    Voltar
                  </v-btn>
                </v-col>
                <v-col cols="6" class="pl-1">
                  <v-btn small :disabled="carregando" :loading="carregando" light width="100%" @click="limpaFiltros('geral'), e6 = 1">
                    Recomeçar
                    <v-icon class="ml-1">mdi-arrow-u-up-left</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="mt-n3">
                  <v-btn small :disabled="carregando" :loading="carregando" class="success" @click="listarProdutosPersonalizados(0), panel=1" width="100%">
                    Buscar Produtos
                    <v-icon class="ml-1">mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <span class="d-none d-md-block">Produtos</span>
          <v-spacer />
          <v-btn
              :disabled="selected.length == 0 || carregando"
              elevation="0"
              class="mx-3"
              color="primary"
              @click="selected = []"
          >
            <span class="d-none d-md-block">Limpar produtos selecionados</span>
            <v-icon class="ml-0 ml-md-2">mdi-close</v-icon>
          </v-btn>
          <v-badge color="green" overlap :content="qtdEtiquetas" :value="qtdEtiquetas" offset-x="27">
            <v-btn class="mr-3" :disabled="qtdEtiquetas == 0 || carregando" elevation="0" color="primary" @click="dialogProdutosSelecionado = true">
              <span class="d-none d-md-block">Imprimir produtos Selecionados</span>
              <v-icon class="ml-0 ml-md-2">mdi-barcode</v-icon>
            </v-btn>
          </v-badge>
          <v-tooltip bottom color="error" class="d-none d-md-block">
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  :disabled="produtos.lista == 0 || carregando || selected.length>0"
                  elevation="0"
                  color="primary"
                  @click="dialogConfirma=true"
              >
                <span class="d-none d-md-block">Imprimir geral</span>
                <v-icon size="22" class="ml-0 ml-md-2">mdi-printer</v-icon>
              </v-btn>
            </template>
            <span><v-icon size="20" color="white" class="mr-1 mt-n1">mdi-alert-circle-outline</v-icon>A impressão será realizada com base no resultado da pesquisa ({{produtos.total}}  produtos)</span>
          </v-tooltip>
        </v-card-title>
        <v-divider v-if="!carregando"/>
        <v-progress-linear indeterminate absolute :active="carregando" />
        <v-card-text class="py-0">
          <v-data-table
              :headers="[
                    { text: 'Qtd. Etiqueta', value: 'quantidade', align:'left',  sortable: false},
                    { text: 'Cód. Barras', value: 'codigobarra', align:'left',  sortable: false},
                    { text: 'Cód. Produto', value: 'idsubproduto', align:'left',  sortable: false},
                    { text: 'Produto', value: 'produto', align:'left',  sortable: false},
                    { text: 'Embalagem', value: 'embalagem', align:'left',  sortable: false},
                ]"
              :items="produtos.lista"
              show-select
              v-model="selected"
              item-key="compositeKey"
              :search="search"
              hide-default-footer
              :items-per-page="-1"
              class="pb-2"
          >
            <template v-if="produtos.total>100" v-slot:top>
              <div class="my-2" >
                <Paginacao
                    :total="produtos.total"
                    @atualizar="listarProdutosPersonalizados"
                    :carregando="carregando"
                    :pg="pgSelecionada"
                    :pgLimitInt="100"
                />
              </div>
              <v-divider />
            </template>
            <template v-if="carregando" v-slot:item="{item}">
              <tr v-if="carregando || !item">
                <td colspan="100%"><v-skeleton-loader class="white" type="table-row" /></td>
              </tr>
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                  hide-details
                  style="width: 110px;"
                  reverse
                  dense
                  type="number"
                  :disabled="!isItemSelected(item) || carregando"
                  :append-icon="!isItemSelected(item)? 'mdi-alert-circle' : ''"
                  v-model.number="item.quantidade"
                  @input="verificaQuantidade(item)"
              ></v-text-field>
            </template>
            <template v-slot:item.codigobarra="{ item }">
              {{  item.codigobarra }}
            </template>
            <template v-slot:item.idsubproduto="{ item }">
              {{  item.idsubproduto }}
            </template>
            <template v-slot:item.produto="{ item }">
              {{  item.produto }}
            </template>
            <template v-slot:item.embalagem="{ item }">
              {{  item.embalagem }}
            </template>
          </v-data-table>
          <v-divider v-if="produtos.lista.length>0" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-dialog v-model="dialogConfirma" width="750px" persistent>
      <v-card>
        <v-card-title>
          Confirmação
        </v-card-title>
        <v-divider/>
        <v-card-text class="py-5">
          A geração da(s) etiquetas terá um total de <strong>{{produtos.total}}</strong> produto(s).<br/>
          Confirma a emissão?
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-col cols="5" class="px-2"><v-btn class="error" @click="dialogConfirma= false" width="100%">Cancelar</v-btn></v-col>
          <v-col cols="7" class="px-2 d-none d-sm-block"><v-btn class="primary" @click="geraEtiquetasGeral()" width="100%">Gerar Etiquetas <v-icon class="ml-2">mdi-download</v-icon></v-btn></v-col>
          <v-col cols="7" class="px-2 d-sm-none"><v-btn class="primary" @click="geraEtiquetasGeral()" width="100%">Gerar <v-icon class="ml-2">mdi-download</v-icon></v-btn></v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogProdutosSelecionado" fullscreen>
      <v-card>
        <v-card-title>
          Produtos Selecionados
          <v-spacer/>
          <v-btn icon @click="dialogProdutosSelecionado = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
              :headers="[
                    { text: 'Qtd. Etiqueta', value: 'quantidade', align:'left'},
                    { text: 'Cód. Barras', value: 'codigobarra', align:'left'},
                    { text: 'Cód. Produto', value: 'idsubproduto', align:'left'},
                    { text: 'Produto', value: 'produto', align:'left'},
                    { text: 'Embalagem', value: 'embalagem', align:'left'},
                ]"
              :items="selected"
              height="calc(100vh - 250px)"
              fixed-header
              show-select
              v-model="selected"
              item-key="compositeKey"
              :search="search"
              hide-default-footer
              :items-per-page="-1"
              item
              class="pb-2"
          >
            <template v-slot:top>
              <v-text-field
                  v-model="search"
                  label="Buscar produto na lista de seleção"
                  placeholder="codigo ou descrição"
                  class="pb-3"
                  outlined
                  dense
                  hide-details
              ></v-text-field>
              <v-divider/>
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                  hide-details
                  style="width: 110px;"
                  reverse
                  dense
                  type="number"
                  :disabled="!isItemSelected(item) || carregando"
                  :append-icon="!isItemSelected(item)? 'mdi-alert-circle' : ''"
                  v-model.number="item.quantidade"
                  @input="verificaQuantidade(item)"
              ></v-text-field>
            </template>
            <template v-slot:item.codigobarra="{ item }">
              {{  item.codigobarra }}
            </template>
            <template v-slot:item.idsubproduto="{ item }">
              {{  item.idsubproduto }}
            </template>
            <template v-slot:item.produto="{ item }">
              {{  item.produto }}
            </template>
            <template v-slot:item.embalagem="{ item }">
              {{  item.embalagem }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="carregando" class="primary" @click="carregandoPdf= true, geraEtiquetas()" width="100%">
            Gerar Etiquetas <v-icon class="ml-2">mdi-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="carregandoPdf" persistent overlay-opacity="0.7" width="500px">
      <v-card color="primary" dark>
        <v-card-text class="pa-5">
          <span>{{ carregandoPdfMensagem }}...</span>
          <v-progress-linear stream color="white"  buffer-value="0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-btn
        v-if="isVisible2"
        class="d-md-none mb-12"
        fixed
        bottom
        right
        :disabled="qtdEtiquetas == 0 || carregando"
        elevation="0"
        color="primary"
        @click="dialogProdutosSelecionado = true"
        fab
    >
      <v-badge color="green" :content="qtdEtiquetas" :value="qtdEtiquetas">
        <v-icon size="30" class="ml-0 ml-md-3">mdi-barcode</v-icon>
      </v-badge>
    </v-btn>
    <v-btn
        class="d-none d-md-block"
        v-if="isVisible"
        fab
        fixed
        bottom
        right
        color="primary"
        @click="scrollToTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </v-row>
</template>

<style scoped>
.v-btn {
  transition: opacity 0.3s;
}

.badge-custom .v-icon {
  font-size: 11px !important; /* Ajuste esse valor conforme necessário */
}
.badge-custom .v-badge__badge {
  margin-right: -18px !important; /* Ajuste esse valor conforme necessário */
}


.pdf-container {
  padding: 0 !important;
  height: calc(100vh - 64px) !important; /* Altura total menos a altura da toolbar */
  overflow: hidden !important;
}

.pdf-container embed {
  width: 100% !important;
  height: 100% !important;
}

.v-dialog__content--active {
  overflow: hidden;
}

fieldset {
  padding: 8px;
  border: solid rgba(255, 255, 255, 0.93) 1px;
  border-radius: 4px;
}

fieldset legend {
  padding: 0px 5px;
  font-size: 0.8em;
}

</style>